module.exports = __webpack_public_path__ + "teqbahn-assets/media/slider_1_icon.43303b87.png";